<template>
    <b-modal
    v-model="openModal"
    title="Cambio de Categoria"
    header-bg-variant="dark"
    header-text-variant="light"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    size="lg"
    >
    <div class="my-3">Tenga en cuenta que esta cambiando la categoria del item, y perdera los siguientes atributos:</div>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">N°</th>
                    <th scope="col">Nombre Atributo</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in removedCategoriesList" :key="index">
                    <td>{{index}}</td>
                    <td>{{item.nombre}}</td>
                    <td><b-icon icon="trash-fill"></b-icon></td>
                </tr>
            </tbody>
        </table>
    </div>
    <template v-slot:modal-footer>
        <b-button size="sm" variant="danger" @click.prevent="$emit('close-modal')">
                Cancelar
        </b-button>
        <b-button size="sm" variant="success" @click.prevent="$emit('confirm-modal')">
                Confirmar
        </b-button>
    </template>
    </b-modal>
</template>

<script>
export default {
    name: "ChangeCategoryModalConfirm",
    props: {
        removedCategoriesList: {
            type: Array
        },
        title: {
            type: String,
            default: ''
        },
        openModal: {
            type: Boolean,
            default: false
        }
    }

};

</script>
